import React from 'react';
import { Helmet } from 'react-helmet';

const CovidResources = () => {


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "COVID-19 Safety Measures - Mauli Cabs",
    "url": "https://www.maulicabs.com/covid-19-resources",  // Replace with actual URL
    "description": "Stay informed about Mauli Cabs' COVID-19 safety protocols. Learn how we ensure a hygienic and secure travel experience with regular sanitization, driver health checks, and contactless bookings."
  };
  

  
  return (
    <>


<Helmet>
    <title>COVID-19 Safety Measures | Mauli Cabs | Safe Travel from Mumbai to Pune</title>
    <meta
      name="description"
      content="Mauli Cabs prioritizes your safety during COVID-19. Discover our preventive measures including vehicle sanitization, driver screenings, and contactless cab booking for Mumbai to Pune trips."
    />
    <meta
      name="keywords"
      content="mauli cabs covid safety, taxi sanitization policy, safe cab service mumbai pune, contactless cab booking, travel during covid-19, mauli cabs health safety, driver covid protocol, hygienic cab service, covid travel resources, mumbai pune cab during pandemic"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>

      {/* Breadcrumb section */}
      <section
        className="vs-breadcrumb"
        style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
      >
        <div className="container">
          <div className="row text-center">
            <div className="col-12">
              <div className="breadcrumb-content">
                <h1 className="breadcrumb-title">Covid 19 Resources</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* COVID Resources Section */}
      <div className="covid-container">
        <h1>COVID-19 Resources & Safety Protections</h1>
        <p>
          Coronavirus has disrupted lives, demanding new safety habits. Social distancing, sanitization, and quarantining are helping prevent the spread. Hygiene and disinfection are critical.
        </p>

        {/* Image of COVID-19 */}
        <section className="covid-image">
          <img src="/images/covid.jpg" alt="COVID-19 Awareness" className="covid-img" />
        </section>

        <section className="cdc-guidance">
          <h2>CDC Recommendations</h2>
          <p>Disinfect frequently touched surfaces to prevent disease spread.</p>
        </section>

        <section className="mauli-intro">
          <h2>Mauli Cabs: Safe Transportation Services</h2>
          <p>We are committed to offering safe private travel by strictly following all COVID safety protocols to ensure our clients’ protection.</p>
        </section>

        <section className="taxi-services">
          <h3>Safe Taxi Service Protocol</h3>
          <ul>
            <li>Hand sanitizers are installed in cabs for client use.</li>
            <li>Vehicles are disinfected before and after every ride.</li>
            <li>Air is circulated in and out of the cab to reduce contamination.</li>
          </ul>
        </section>

        <section className="driver-safety">
          <h3>Driver Safety Measures</h3>
          <ul>
            <li>Drivers wear masks at all times and carry sanitizers.</li>
            <li>Vehicles are sprayed with disinfectants regularly.</li>
            <li>Social distancing is maintained with passengers.</li>
          </ul>
        </section>

        <section className="client-safety">
          <h3>Client Safety Tips</h3>
          <ul>
            <li>Wear facemasks and carry hand sanitizer.</li>
            <li>Install the Arogya Setu App with Bluetooth enabled.</li>
            <li>Load your own luggage and keep distance from the driver.</li>
            <li>Dispose of used tissues and cloths outside the vehicle.</li>
            <li>Turn off AC when not needed and prefer fresh air by opening windows.</li>
          </ul>
        </section>

        <footer className="covid-footer">
          <p>We wish you a safe, secure, and relaxing journey with Mauli Cabs.</p>
        </footer>
      </div>
    </>
  );
};

export default CovidResources;
